import config from '@sketch/env-config'

/**
 * Where the renderer fetches a page's images and fragments from. The page path
 * is permanent across versions; the token is the version's own, which is what
 * scopes the request to it.
 */
export function presentationURLFormats(
  pageUUID: string,
  imageToken?: string | null
) {
  const base = `${config.web_renderer_image_domain}/presentation/p/${pageUUID}`

  return {
    imagesURLFormat: `${base}/i/:imageId?token=${imageToken}&format=:format`,
    fragmentsURLFormat: `${base}/f/:fragmentId?token=${imageToken}`,
  }
}
